import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.blocked-users', {
        url: '/blocked-users',
        component: 'companyUserDirectoriesSaaspassUsersBlockedUsers',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/blocked-users/blocked-users.state.js